// import React, { useState } from "react";
// import logo from "../images/logo.jpg"; 

// const WoodlandEscapeBookingForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//     date: "",
//     nights: "",
//     guests: "",
//     message: "",
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.id]: e.target.value });
//   };

//   const sendWhatsApp = () => {
//     const { name, phone, date, nights, guests, message } = formData;
//     if (!name || !phone || !date || !nights || !guests) {
//       alert("Please fill all required fields.");
//       return;
//     }

//     const text = `🌿 *Woodland Escape Resort Booking* 🌿
// Name: ${name}
// Phone: ${phone}
// Check-in Date: ${date}
// Stay: ${nights}
// Guests: ${guests}
// Request: ${message || "None"}
// `;

//     const encodedText = encodeURIComponent(text);
//     window.open(`https://wa.me/9175577266?text=${encodedText}`, "_blank");
//   };

//   return (
// <>

// <section
//   className="page-title"
//   style={{
//     backgroundImage: `
//       linear-gradient(
//         rgba(0, 0, 0, 0.6),
//         rgba(0, 0, 0, 0.6)
//       ),
//       url(/images/page-title.jpg)
//     `,
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   }}
// >
//   <div className="auto-container">
//     <div className="text-center">
//             <h1>Booking</h1>
//     </div>
//   </div>
// </section>

 
//     <div className="booking-container">
//       <div className="booking-form">
//         <img src={logo} alt="Woodland Escape Logo" className="resort-logo" />
//         <h2>Woodland Escape Booking</h2>

//         <div className="form-group">
//           <label>Full Name</label>
//           <input type="text" id="name" value={formData.name} onChange={handleChange} />
//         </div>

//         <div className="form-group">
//           <label>Phone Number</label>
//           <input type="tel" id="phone" value={formData.phone} onChange={handleChange} />
//         </div>

//         <div className="form-group">
//           <label>Check-in Date</label>
//           <input type="date" id="date" value={formData.date} onChange={handleChange} />
//         </div>

//         <div className="form-group">
//           <label>Number of Nights</label>
//           <select id="nights" value={formData.nights} onChange={handleChange}>
//             <option value="">Select</option>
//             <option>1 Night</option>
//             <option>2 Nights</option>
//             <option>3 Nights</option>
//             <option>4+ Nights</option>
//           </select>
//         </div>

//         <div className="form-group">
//           <label>Number of Guests</label>
//           <input type="number" id="guests" value={formData.guests} onChange={handleChange} />
//         </div>

//         <div className="form-group">
//           <label>Special Request</label>
//           <textarea
//             id="message"
//             rows="3"
//             value={formData.message}
//             onChange={handleChange}
//             placeholder="Any special requirements?"
//           />
//         </div>

//        <button className="book-now-btn" onClick={sendWhatsApp}>
//   Book Now on WhatsApp
// </button>


//         <div className="footer">
//           📞 Contact: <strong>+91 9175577266</strong> <br />
//           🌲 Woodland Escape Resort
//         </div>
//       </div>
//     </div>

// </>
//   );
// };

// export default WoodlandEscapeBookingForm;












import React, { useState } from "react";
import logo from "../images/logo.jpg";

const WoodlandEscapeBookingForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    date: "",
    nights: "",
    guests: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const sendWhatsApp = () => {
    const { name, phone, date, nights, guests, message } = formData;

    if (!name || !phone || !date || !nights || !guests) {
      alert("Please fill all required fields.");
      return;
    }

    const text = `🌿 *Woodland Escape Resort Booking* 🌿
    
Name: ${name}
Phone: ${phone}
Check-in Date: ${date}
Stay: ${nights}
Guests: ${guests}
Special Request: ${message || "None"}
`;

    const encodedText = encodeURIComponent(text);
    window.open(
      `https://wa.me/917620411277?text=${encodedText}`,
      "_blank"
    );
  };

  return (
    <>
      {/* PAGE TITLE */}
      <section
        className="page-title"
        style={{
          backgroundImage: `
          linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)),
          url(/images/page-title.jpg)
        `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="auto-container text-center">
          <h1>Booking</h1>
        </div>
      </section>

      {/* BOOKING FORM */}
      <div className="booking-container">
        <div className="booking-form wide-form">
          <img src={logo} alt="Woodland Escape Logo" className="resort-logo" />

          <h2>Woodland Escape Booking</h2>

          <div className="form-group">
            <label>Full Name *</label>
            <input
              type="text"
              id="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Phone Number *</label>
            <input
              type="tel"
              id="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Check-in Date *</label>
            <input
              type="date"
              id="date"
              value={formData.date}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Number of Nights *</label>
            <select
              id="nights"
              value={formData.nights}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option>1 Night</option>
              <option>2 Nights</option>
              <option>3 Nights</option>
              <option>4+ Nights</option>
            </select>
          </div>

          <div className="form-group">
            <label>Number of Guests *</label>
            <input
              type="number"
              id="guests"
              value={formData.guests}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>Special Request</label>
            <textarea
              id="message"
              rows="3"
              value={formData.message}
              onChange={handleChange}
              placeholder="Any special requirements?"
            />
          </div>

          <button className="book-now-btn" onClick={sendWhatsApp}>
            Book Now on WhatsApp
          </button>

          <div className="footer">
            📞 Contact: <strong>+91 7620411277</strong> <br />
            🌲 Woodland Escape Resort
          </div>
        </div>
      </div>
    </>
  );
};

export default WoodlandEscapeBookingForm;
